import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MenuPage from './pages/menu-page';
import CheckoutFlow from './pages/checkout-flow';
import OrderHistory from './pages/order-history';
import OrderDetailsPage from './pages/order-details';
import QueueStatus from './pages/queue-status';
import QueueHistory from './pages/queue-history';
import ProfilePage from './pages/profile-page';
import ReservationFlow from './pages/reservation-flow';
import RestaurantShell from './pages/restaurant-shell';

const CustomerPortalPage = React.lazy(() => import('./pages/customer-portal'));

const AppRoutes = () => {
  return (
    <Routes>
      {/* Direct short QR code scan route for customer rewards portal */}
      <Route
        path="/c/:token"
        element={
          <React.Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
            <CustomerPortalPage />
          </React.Suspense>
        }
      />
      {/* Interactive UI Demo Routes */}
      <Route
        path="/demo"
        element={
          <React.Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
            <CustomerPortalPage />
          </React.Suspense>
        }
      />
      <Route
        path="/demo/portal"
        element={
          <React.Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
            <CustomerPortalPage />
          </React.Suspense>
        }
      />

      {/*
        Primary URL pattern: /restaurant/:restaurantId
        Optional: /restaurant/:restaurantId?table=3
        All sub-pages (checkout, orders, profile) also live under this path
        so the restaurantId is always in the URL on every page / refresh.
      */}
      <Route path="/restaurant/:restaurantId" element={<RestaurantShell />}>
        <Route index element={<MenuPage />} />
        <Route path="checkout" element={<CheckoutFlow />} />
        <Route path="orders" element={<OrderHistory />} />
        <Route path="orders/:orderId" element={<OrderDetailsPage />} />
        <Route path="queue-status" element={<QueueStatus />} />
        <Route path="queue-history" element={<QueueHistory />} />
        <Route path="reservation" element={<ReservationFlow />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route
          path="rewards"
          element={
            <React.Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
              <CustomerPortalPage />
            </React.Suspense>
          }
        />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const NotFound = () => (
  <div className="min-h-screen flex flex-col items-center justify-center text-gray-500 gap-3">
    <p className="text-4xl">🍽️</p>
    <p className="text-lg font-semibold">No restaurant found</p>
    <p className="text-sm">Please scan the QR code or use a valid restaurant link.</p>
  </div>
);

export default AppRoutes;
